import {Component, Input} from "@angular/core";
import {VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {IQuestStage} from "../../interfaces/quest.definition";


@Component({
    selector: "nv-achievement-stage",
    templateUrl: "./nv-achievement-stage.component.html"
})


export class NvAchievementStageComponent {
  UI_TEXTS = UI_TEXTS;
    VAL_TYPES = VALUE_TYPE;

    @Input() document: IQuestStage;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-achievement-stages/nv-achievement-stage.component.ts